import {Theme} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import moment, {Moment} from 'moment';
import Input from 'src/view/components/input/Input';

export interface DatePickerProps {
    value: Date | Moment | null;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onChange?: (date: Moment | null) => void;
    onOpen?: () => void;
    minDate?: Moment;
    maxDate?: Moment;
    minTime?: Moment;
    maxTime?: Moment;
    disabled?: boolean;
    disableTyping?: boolean;
    placeholder?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    datePickerContainer: {
        width: '100%',
        backgroundColor: theme.colors.lightestGrey,
        margin: 0,
        '& .MuiFormHelperText-root': {
            backgroundColor: 'white',
            margin: 0,
            paddingTop: 0,
        },
    },
    input: {},
}));

export default function DateTimePickerMui({
                                              value,
                                              onChange,
                                              minDate,
                                              minTime,
                                              maxTime,
                                              maxDate,
                                              disabled,
                                              placeholder,
                                              onOpen,
                                          }: DatePickerProps): JSX.Element {
    const classes = useStyles();
    const date = value ? moment(value) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker<Moment>
                className={classes.datePickerContainer}
                slots={{
                    textField: Input,
                }}
                slotProps={{
                    textField: {
                        placeholder,
                        className: classes.input,
                    },
                }}
                onOpen={onOpen}
                ampm={false}
                format="DD/MM/YYYY HH:mm"
                minDate={minDate}
                maxDate={maxDate}
                maxTime={maxTime}
                minTime={minTime}
                disabled={disabled}
                value={date}
                onChange={(date) => {
                    onChange?.(date);
                }}
                minutesStep={1}
            />
        </LocalizationProvider>
    );
}
